"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var _toolkit = require("@ui-propulsion/toolkit");

var _default = (0, _styles.makeStyles)(function () {
  return {
    root: {
      color: _toolkit.lendingClubPalette.denim[300]
    }
  };
}, {
  name: 'PdsFormHelperText'
});

exports.default = _default;
